import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FlagToggle from './FlagToggle';

/**
 * HussarTopNav — global top navigation for HussarAi.
 *
 * HussarAi is the European immigration-record-integrity platform. LeadWing
 * was extracted to /app/leadwing_extracted/ on 2026-02-10 and no longer
 * appears in HussarAi navigation, footer, sitemap, or analytics. If LeadWing
 * needs a public nav again it belongs on its own Emergent project/domain.
 */
const HUSSARAI_ITEMS = (t) => [
  { key: 'mojeAkta',        to: '/moje-akta-imigracyjne',      label: t('hussarNav.mojeAkta'),         match: ['/moje-akta-imigracyjne', '/my-immigration-record'] },
  { key: 'forProfessionals', to: '/dla-profesjonalistow',      label: t('hussarNav.forProfessionals'), match: ['/dla-profesjonalistow', '/for-professionals'] },
  { key: 'forInstitutions',  to: '/dla-instytucji',            label: t('hussarNav.forInstitutions'),  match: ['/dla-instytucji', '/for-institutions'] },
  { key: 'security',         to: '/bezpieczenstwo-i-zgodnosc', label: t('hussarNav.security'),         match: ['/bezpieczenstwo-i-zgodnosc'] },
  { key: 'pilot',            to: '/pilot-publiczny',           label: t('hussarNav.pilot'),            match: ['/pilot-publiczny'] },
];

const HussarTopNav = ({ active }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const items = HUSSARAI_ITEMS(t);

  const isActive = (item) => {
    if (active && active === item.key) return true;
    if (item.match) return item.match.some((p) => location.pathname.startsWith(p));
    return false;
  };

  return (
    <nav className="hussar-topnav" data-testid="hussar-topnav" aria-label="HussarAi global navigation">
      <div className="hussar-topnav-inner">
        <Link to="/" className="hussar-topnav-brand" data-testid="hussar-topnav-brand">
          <img src="/hussarai-logo-full.png" alt="HussarAi" className="hussar-topnav-logo" />
        </Link>
        <ul className="hussar-topnav-links">
          {items.map((item) => (
            <li key={item.key}>
              <Link
                to={item.to}
                className={`hussar-topnav-link${isActive(item) ? ' is-active' : ''}`}
                data-testid={`hussar-topnav-${item.key}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="hussar-topnav-actions">
          <FlagToggle />
        </div>
      </div>
    </nav>
  );
};

export default HussarTopNav;
